import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [CommonModule, TranslateModule, MatSnackBarModule],
})
export class CommonFunctionModule {}
